import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { fetchRoleDetail } from '@/api/access/accessApi';
import type { RoleDetail } from '@/api/access/accessApi.types';
import { buildRoleQueryKey } from '@/constants/queryKeys';

export function useRoleDetailQuery(
  roleId: string | null
): UseQueryResult<RoleDetail, Error> {
  return useQuery({
    queryKey: buildRoleQueryKey(roleId === null ? 'none' : roleId),
    queryFn: function loadRoleDetail() {
      if (roleId === null) {
        return Promise.reject(new Error('A role identifier is required.'));
      }
      return fetchRoleDetail(roleId);
    },
    enabled: roleId !== null,
  });
}
